var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#303030",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_6788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99998 6.58334C8.41419 6.58334 8.74998 6.91912 8.74998 7.33334V11.3333C8.74998 11.7476 8.41419 12.0833 7.99998 12.0833C7.58577 12.0833 7.24998 11.7476 7.24998 11.3333V7.33334C7.24998 6.91912 7.58577 6.58334 7.99998 6.58334Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99882 2.08334C6.96077 2.08174 5.94075 2.35469 5.04222 2.87452C4.68369 3.08195 4.22489 2.95945 4.01746 2.60091C3.81004 2.24238 3.93253 1.78358 4.29107 1.57615C5.41857 0.923848 6.69854 0.58133 8.00114 0.583337C12.0968 0.583961 15.4166 3.90417 15.4166 8C15.4166 12.0962 12.0962 15.4167 7.99998 15.4167C3.90377 15.4167 0.583313 12.0962 0.583313 8C0.583313 6.65075 0.944467 5.38221 1.57623 4.29091C1.78376 3.93243 2.2426 3.81006 2.60107 4.01759C2.95955 4.22512 3.08192 4.68395 2.87439 5.04243C2.37149 5.91113 2.08331 6.92126 2.08331 8C2.08331 11.2678 4.73219 13.9167 7.99998 13.9167C11.2678 13.9167 13.9166 11.2678 13.9166 8C13.9166 4.73222 11.2678 2.08334 7.99998 2.08334L7.99882 2.08334Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 5.85001C8.41419 5.85001 8.74998 5.51422 8.74998 5.10001C8.74998 4.6858 8.41419 4.35001 7.99998 4.35001C7.58577 4.35001 7.24998 4.6858 7.24998 5.10001C7.24998 5.51422 7.58577 5.85001 7.99998 5.85001Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_6788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.6cac0dee.svg";
export { ForwardRef as ReactComponent };